module.exports = {"classes":["mfa-page"],"title":"Auth0 Guardian","metas":{},"opengraph":{},"twittercard":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/jp/guardian/metadata.json
// module id = 1515
// module chunks = 0